/* eslint-disable no-restricted-syntax */
import { user, util, os, cache } from '@tencent/ppd-base-libs';
import { collectPageInfo } from './page-performance';

const ELK_REPORT_URL = `${location.protocol}//ft.moneydata.hk/elk/report/?newVersion=1&`;
/** 业务名称 */
const BUSINESS_NAME = 'discount-center';
/** ELK Key名称 */
const ELK_KEY = 'discount_center_page_timing_1';

/** 设置flag */
let needReport = true;

const report = () => {
  const res = collectPageInfo(timeObj.viewHome);
  console.log(ELK_KEY, res, timeObj);
  if (res.valid) {
    const key = `${BUSINESS_NAME}_${process.env.VUE_APP_SENTRY_VERSION}_performance_loaded`;
    // 上报 HTML 下载时间、资源加载时间、JS执行时间
    elkReport({
      key: ELK_KEY,
      // 链接时间
      timeDiff: res.connectTime,
      // HTML 建立连接、下载时间
      series_no: res.HTMLDownloaded,
      // 资源下载时间
      msg_segment: res.resourceLoaded,
      // js 执行时间
      errCode: res.JSRuntime,
      // 0 无缓存，1 部分缓存，2 全缓存
      str1: res.cacheType.toString(),
      // 区分用户是否有重定向
      // str2: /code=/.test(location.href) ? 'HAS_CODE' : 'NO_CODE',
      // 区分用户是首次访问还是二次访问
      str3: cache.getItemSync(key) === '1' ? '1' : '0',
      /** 手机型号 */
      str4: getBrandAndSystem().brand,
      num1: res.idleTime,
      num2: res.dnsLookup.toString(),
      num3: res.tcp.toString(),
      num4: res.ssl.toString(),
      num5: res.ttfb.toString(),
      num6: timeObj.main - res.lastResourceTime,
      num7: timeObj.createdHome - timeObj.main,
      num8: res.FCPTime,
      // 不上报具体的资源加载时间，避免内容超大上报失败
      // msg: res.msg,
    });
    cache.setItemSync(key, '1', 1000 * 60 * 60 * 24 * 365 * 5);
  }
};

/** 因base-libs上报限定了字符类型，这里使用自定义elk上报 */
export const elkReport = (params = {}) => {
  const defaultConfig = getDefaultConfig();

  const formatParams = util.objectToGetParams({
    ...defaultConfig,
    ...params,
  }, false);
  const url = `${ELK_REPORT_URL}${formatParams}`;
  util.imgReport(url);
};

const getDefaultConfig = () => ({
  nodeType: 'ppd_web_hkwallet',
  uin: user.getUin(),
  channel: `${BUSINESS_NAME}`,

  client_time: new Date().getTime(),  // 客户端时间
  system_ver: os.getOSInfoText(),   // 系统版本 eg: iphone 11.0
  weixin_ver: os.getWeixinVer(),    // 微信版本 eg: 7.0.12
});

/**
 * 获取机型信息
 */
function getBrandAndSystem() {
  let brand = '';
  let system = '';
  try {
    const ua = window.navigator.userAgent;
    const isIphone = /iPhone/.test(ua);
    const isAndroid = /Android/.test(ua);
    const macthes = ua.match(/^.*?(\(.*?\)).*$/);
    if (macthes && macthes.length > 1) {
      const infoSplit = macthes[1]
        .replace(/[()]/g, '')
        .split(';');

      if (isIphone) {
        brand = infoSplit[0].trim();
        system = infoSplit[1].trim();
      }

      if (isAndroid) {
        brand = infoSplit[2].trim();
        system = infoSplit[1].trim();
      }
    }
  } catch (err) {

  }
  return { brand, system };
}

type TimingPoints = 'main' | 'createdHome' | 'viewHome';

const timeObj: Record<TimingPoints, number> = {
  main: 0,
  createdHome: 0,
  viewHome: 0,
};

/** 设置是否上传性能数据 */
export const setNeedReport = (report: boolean) => needReport = report;

export const reportPerformance = () => {
  if (!needReport) {
    return;
  }
  needReport = false;
  try {
    report();
  } catch (e) { }
};

/** 打点记录时间，从 navigationStart 至当前执行时间 */
export const setTiming = (str: TimingPoints) => {
  try {
    if (timeObj[str] > 0) {
      return;
    }
    if (window.performance && window.performance.timing) {
      timeObj[str] = Date.now() - performance.timing.navigationStart;
    }
  } catch (e) { }
};
